import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function MfproductInfo(){
  const { mfproductObj} = useSelector((state)=>state.manufslice.mfproductDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ mfproductObj.businessid!==null && mfproductObj.businessid!==undefined?mfproductObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ mfproductObj.title!==null && mfproductObj.title!==undefined?mfproductObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="imageurl"  value={ mfproductObj.imageurl!==null && mfproductObj.imageurl!==undefined?mfproductObj.imageurl:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Description"  value={ mfproductObj.description!==null && mfproductObj.description!==undefined?mfproductObj.description:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Code"  value={ mfproductObj.code!==null && mfproductObj.code!==undefined?mfproductObj.code:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Stock Count"  value={ mfproductObj.stockcount!==null && mfproductObj.stockcount!==undefined?mfproductObj.stockcount:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Category Id"  value={ mfproductObj.categoryid!==null && mfproductObj.categoryid!==undefined?mfproductObj.categoryid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Category Name"  value={ mfproductObj.categoryname!==null && mfproductObj.categoryname!==undefined?mfproductObj.categoryname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Stock Incoming"  value={ mfproductObj.stockincoming!==null && mfproductObj.stockincoming!==undefined?mfproductObj.stockincoming:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Price"  value={ mfproductObj.price!==null && mfproductObj.price!==undefined?mfproductObj.price:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}